import Color from 'color';
import { ReactNode } from 'react';
import {
  ColorPickerLibraryItem,
  findColorLibraryItem,
  type ColorPickerLibrary
} from './ColorPicker.library';

export function normalizeHex(value: string): string | undefined {
  const raw = value.trim();
  if (!raw) {
    return undefined;
  }
  try {
    return Color(raw).hex();
  } catch {
    return undefined;
  }
}

export function isLightColor(value: string): boolean {
  try {
    return Color(value).isLight();
  } catch {
    return true;
  }
}

export function resolveColorDisplay(
  library: ColorPickerLibrary,
  value: string
): {
  hex?: string;
  name?: string;
  swatchRender?: ReactNode;
} {
  const item = findColorLibraryItem(library, value);
  if (item) {
    return {
      hex: normalizeHex(item.value) ?? item.value,
      name: item.name,
      swatchRender: item.render
    };
  }

  const hex = normalizeHex(value);
  if (hex) {
    return { hex, name: hex };
  }

  return {};
}

export function resolveColorLibraryItemId(
  library: ColorPickerLibrary,
  value: string
): string | undefined {
  return findColorLibraryItem(library, value)?.id;
}

export function resolveColorLibraryItemValue(
  item: ColorPickerLibraryItem
): string {
  return normalizeHex(item.value) ?? item.value;
}
